export class FreightForwarder {
    id: number;
    name: string;
    address: string;
    countryId: number;
    poBox: number;
    phoneNumber: string;
    emailAddress: string;
    webSiteUrl: string;
    crNumber: number;
    latitude: number;
    longitude: number;
    logo: string;
    placeId: string;
    companyStatus: string;
    odooId: number;
    defaultContactId: number;
    companyId: number;
}
